import { axios } from '@/utils/request'

// /**
//  * 我的全部课程列表
//  */
// export function getMineCourse(courseType, pageNo, pageSize) {
//     return axios({
//       url: "/teaching/teachingCourse/mineCourse",
//       method: "get",
//       params: {courseType, pageNo, pageSize}
//     });
//   }
// //获取课程信息
// export function getCourseInfo(courseId){
//   return axios({
//     url: "/teaching/teachingCourse/mineCourse?courseId="+courseId,
//     method: "get"
//   });
// }

/**
 * 学生全部课程列表
 */
export function getMineCourse({courseId, courseType, pageNo = 1, pageSize = 99}) {
  return axios({
    url: "/teaching/teachingCourse/studentCourseNew",
    method: "get",
    params: {courseId, courseType, pageNo, pageSize}
  });
}

/**
 * 教师课程列表
 */
export function getTeacherCourse({courseId, courseType, pageNo = 1, pageSize = 99}) {
  return axios({
    url: "/teaching/teachingCourse/teacherCourse",
    method: "get",
    params: {courseId, courseType, pageNo, pageSize}
  });
}

/**
 * 获取课程单元
 */
export function getCourseUnit(courseId) {
  return axios({
    url: "/teaching/teachingCourseUnit/getCourseUnit",
    method: "get",
    params: {
      courseId
    }
  });
}

/**
 * 获取班级课程单元的开课时间
 */

export function getDepartUnitSchedule(courseId, departId) {
  return axios({
    url: "/teaching/teachingCourseUnit/getDepartUnitSchedule",
    method: "get",
    params: {
      courseId, departId
    }
  });
}

/**
 * 手动修改单元排课
 * @param {*} param0 
 */
export function setUnitScheduleManual({unitId, departId, isUnitOpen, isWorkOpen, isVideoOpen, isWorkCaseOpen}){
  return axios({
    url: "/teaching/teachingCourseUnit/setUnitScheduleManual",
    method: "put",
    params: {
      unitId, departId, isUnitOpen, isWorkOpen, isVideoOpen, isWorkCaseOpen
    }
  });
}

//获取课程下的所有作业
export function mineCourseWork({coruseId, departId, submit, status}){
  return axios({
    url: "/teaching/teachingWork/mineCourseWork",
    method: "get",
    params:{coruseId, departId, submit, status},
  })
}

//获取附加作业
export function mineAdditionalWork({departId, submit, status}){
  return axios({
    url: "/teaching/teachingWork/mineAdditionalWork",
    method: "get",
    params:{departId, submit, status}
  })
}

//获取老师课程作业
export function teacherCourseWork({codeType, workStatus, departId, unitId, additionalWorkId, workName, workScene, pageNo, pageSize}){
  return axios({
    url: "/teaching/teachingWork/teacherCourseWork",
    method: "get",
    params: {codeType, workStatus, departId, unitId, additionalWorkId, workName, pageNo, workScene, pageSize}
  })
}
//获取老师附加作业
export function teacherAdditionalWork(){
  return axios({
    url: "/teaching/teachingWork/teacherAdditionalWork",
    method: "get",
    params: {}
  })
}

//获取课程单元信息
export function getCourseUnitInfo(unitId){
  return axios({
    url: "/teaching/teachingCourseUnit/queryById",
    method: "get",
    params:{
      id: unitId
    }
  })
}

/**
 * 获取学生课程单元
 */
export function getStudentCourseUnit(departId, courseId, pageNo, pageSize) {
    return axios({
      url: "/teaching/teachingCourseUnit/mineUnit",
      method: "get",
      params: {
        courseId,
        departId,
        pageNo,
        pageSize
      }
    });
  }
  
  /**
 * 获取课程单元下的课件
 */
export function getCourseCourseware(unitId) {
    return axios({
      url: "/teaching/teachingCourseMedia/getMediaList",
      method: "get",
      params: {
        unitId
      }
    });
  }

/**
 * 记录学习日志
 */
export function studyLog(
  mediaId,
  mediaType,
  videoTime,
  progress,
  unitId,
  duration,
  finished,
  courseId
) {
  return axios({
    url: "/teaching/teachingStudyLog/study",
    method: "get",
    params: {
      mediaId,
      mediaType,
      videoTime,
      progress,
      unitId,
      duration,
      finished,
      courseId
    }
  });
}
  

  /**
   * 获取我的评价
   */
  export function getMineReview(){
      return axios({
          url: "/teaching/teachingWork/mineReview?pageSize=100",
          method: "get"
      })
  }

  /**
   * 最新开课的一节课
   */
  export function getNewCourse(){
    return axios({
      url: "/teaching/teachingCourse/getNewCourse",
      method: "get"
    })
  }